module.exports = __webpack_public_path__ + "img/logo.33b15f3e.png";